export default function Activities() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-4">
      <h1 className="text-3xl font-semibold tracking-tight">Activities & Nearby</h1>
      <ul className="grid md:grid-cols-2 gap-3 list-disc pl-6 text-foreground/80">
        <li>Waterfalls and nature trails</li>
        <li>Hot springs</li>
        <li>Cycling through countryside lanes</li>
        <li>Stargazing under clear skies</li>
      </ul>
    </section>
  );
}
